import React from "react";

import "./style.scss";

export const Wrapp = props => {
  return <div className="Article-wrapp">{props.children}</div>;
};
